import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "@emotion/styled"
import { FaVideo, FaDog, FaStickyNote, FaPencilAlt } from "react-icons/fa"
import { FiTag } from "react-icons/fi"
import { GiSheep } from "react-icons/gi";

/* Work Header Styles */
const WorkHeaderContainer = styled.div`
    text-align: center;
    margin-bottom: 3rem;
`

const WorkHeader = styled.h1`
    font-size: 3rem;
    margin: 0;
    

    @media (max-width: 425px) {
        margin-top: 5rem;
    }
`
const RedPopColor = styled.span`
    color: #f80c16;
`

const WorkSubTagline = styled.p`
    margin: 0;

    @media (max-width: 425px) {
        width: 85%;
        margin: 0 auto;
    }
`

/*Work Examples Styles */
const WorkExamplesContainer = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    @media (max-width: 425px) {
        flex-direction: column;
    }
`
const WorkExampleInfoContainer = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    width: 50%;
    margin-bottom: 3rem;

    @media (max-width: 425px) {
        width: 100%;
    }
`
const WorkExampleLogo = styled.div`
    font-size: 10rem;
    color: #000000FF;
    margin-bottom: 0.5rem;
`

const WorkTitle = styled.h2`
    margin-bottom: 0.5rem;
    font-size: 2rem;
    color: #f80c16;
`
const WorkDescription = styled.p`
    font-weight: 500;
    width: 75%;
    margin: 0 auto;
    margin-bottom: 1rem;

    @media (max-width: 425px) {
        width: 85%;
    }
`

const WorkLang = styled.h5`
    text-transform: uppercase;
    letter-spacing: 0.05rem;
    width: 75%;
    line-height: 1.1rem;
`

/* Button for Work Examples */

const WorkExampleWrapper = styled.div`
    display: relative;
    cursor: pointer;
    z-index: 0;
`

const WorkExampleLink = styled.a`
    display: inline-block;
    padding: .25rem 1rem;
    font-size: 1rem;
    font-family: Raleway, sans-serif;
    text-decoration: none;
    color: #000000FF;
    border: 2px solid #000000FF;
    border-radius: 10rem;
    letter-spacing: .15rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    position: relative;
    overflow: hidden;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;

    &:after {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 0%;
		height: 100%;
        background: #f80c16;
        border-radius: 10rem;
        z-index: -1;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s; 
    }

    &:hover {
        color: #ffff;
    }

    &:hover:after {
        width: 100%; 
    }
`

/* GitHub Container Styles */

const GitHubInfoContainer = styled.div`
    text-align: center;
`

const GitHubInfo = styled.h2`
    font-family: Raleway, sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.5rem;
`

const GitHubLink = styled.a`
    text-decoration: underline solid #f80c16;
`

/* Work Example Object */

const WorkInfo = props => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <WorkTitle>{props.title}</WorkTitle>
        <WorkDescription>{props.description}</WorkDescription>
        <WorkLang>{props.lang}</WorkLang>
        <WorkExampleWrapper>
            <WorkExampleLink href={props.link} target="_blank" rel="noopener noreferrer">View More +</WorkExampleLink>
        </WorkExampleWrapper>
    </div>
)

export default () => (
    <Layout>
        <SEO title="Work" />
        <WorkHeaderContainer>
            <WorkHeader>My Work<RedPopColor>.</RedPopColor></WorkHeader>
            <WorkSubTagline>(These are the portfolio examples you are looking for...)</WorkSubTagline>
        </WorkHeaderContainer>
        <WorkExamplesContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <FaPencilAlt />
                </WorkExampleLogo>
                <WorkInfo
                    title="Robert Whitlow"
                    description="A website redesign for a best-selling author."
                    lang="Gatsby.js, React, GraphQL, Emotion"
                    link="https://robertwhitlow.com/"
                />
            </WorkExampleInfoContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <FaVideo />
                </WorkExampleLogo>
                <WorkInfo
                    title="Storto Productions"
                    description="A website for a video production company based out of Phoenix, AZ"
                    lang="Gatsby.js, React, GraphQL, Emotion"
                    link="https://storto-productions.com/"
                />
            </WorkExampleInfoContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <FaDog />
                </WorkExampleLogo>
                <WorkInfo
                    title="Me &amp; Bobby McGee"
                    description="A faux author e-commerce website promoting her latest book about her travels with her dalmatian, Bobby"
                    lang="Gatsby.js, React, Stripe, GraphQL, Emotion"
                    link="https://me-and-bobbymcgee.netlify.com/"
                />
            </WorkExampleInfoContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <GiSheep />
                </WorkExampleLogo>
                <WorkInfo
                    title="Rosemary &amp; Thyme"
                    description="A faux company website promoting their eco-friendly clothing"
                    lang="HTML, SASS, JavaScript, Open-Source"
                    link="https://axthomas29.github.io/rosemary-and-thyme/"
                />
            </WorkExampleInfoContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <FaStickyNote />
                </WorkExampleLogo>
                <WorkInfo
                    title="Sticky Note App"
                    description="A simple, interactive application for users to write, search, save, and delete notes"
                    lang="React.js &amp; CSS"
                    link="https://codesandbox.io/embed/sticky-note-app-v6ssm"
                />
            </WorkExampleInfoContainer>
            <WorkExampleInfoContainer>
                <WorkExampleLogo>
                    <FiTag />
                </WorkExampleLogo>
                <WorkInfo
                    title="Name Tag Generator"
                    description="A simple, interactive application for users to create and delete name tags"
                    lang="React.js &amp; CSS"
                    link="https://codesandbox.io/embed/name-tag-generator-app-1usvc"
                /> 
            </WorkExampleInfoContainer>
        </WorkExamplesContainer>
        <GitHubInfoContainer>
            <GitHubInfo>For more of my recent work, you can visit my <GitHubLink href="https://github.com/axthomas29" target="_blank" rel="noopener">GitHub</GitHubLink></GitHubInfo>
        </GitHubInfoContainer>
    </Layout>
)